// jQuery wrapper
($ => {
    $.fn.SlimTabs = function (parameters) {
        return this.each(function () {
            var feedback = new Bookhus.SlimTabs($(this), parameters);
        });
    };
})(jQuery);

module Bookhus {

     export interface ISlimTabsParameters {
         separationTrigger: string;
         separationWrapper: string;
         hideSeparatorElement: boolean;
     }

     export class SlimTabs {
         private origin: JQuery;
         private originId: string;
         private parameters: ISlimTabsParameters;

         constructor(origin: JQuery, parameters: ISlimTabsParameters) {
             this.origin = origin;
             this.originId = origin.attr("id");
             this.parameters = parameters;
             if (this.parameters === undefined) {
                 this.parameters = this.getDefaultParameters();
             }
             this.generateSlimTabs();
             this.changeToTabFromUrlFragment(0);
             $(window).on("hashchange",() => {
                 this.changeToTabFromUrlFragment(400);
             });
         }
        private getDefaultParameters(): ISlimTabsParameters {
            return {
                separationTrigger: "h3",
                separationWrapper: "div",
                hideSeparatorElement: true
        };
        }

        private generateSlimTabs(): void {
            var separators = this.origin.find(this.parameters.separationTrigger);
            if (separators.length <= 1) {
                return;
            }
            // Add pane container
            this.origin.wrapInner(`<div class="slimtabs-panes"></div>`);
            var panes = this.origin.find(".slimtabs-panes");
            // Add tab container
            this.origin.prepend(`<ul class="slimtabs-tabs"></ul>`);
            var tabs = this.origin.find(".slimtabs-tabs");
            // Add tab and pane for each separator
            separators.each((index, element) => {
                var separator = $(element);
                var tabText = separator.html();
                var fragment = tabText.toLowerCase().replace(/\W/g, "_");
                this.addSlimTab(tabs, index, tabText, fragment);
                // Wrap content in pane and add id for fragment linking
                separator.after(`<span id="${fragment}"></span>`).nextUntil(this.parameters.separationTrigger).addBack().wrapAll(this.getSlimPane(index));
            });
            if (this.parameters.hideSeparatorElement) {
                panes.find(this.parameters.separationTrigger).addClass("hiddenSeparator");
            }
        }
        private addSlimTab(tabs: JQuery, index: number, tabText: string, fragment: string): void {
            var visibility = index === 0 ? ` class="active"` : "";
            var tab = $(`<li${visibility}></li>`);
            var link = $(`<a href="#${fragment}">${tabText}</a>`);
            link.on("click", event => {
                event.preventDefault();
                window.location.hash = fragment;
            });
            tab.append(link);
            tabs.append(tab);
        }
        private getSlimPane(index: number): string {
            var element = this.parameters.separationWrapper;
            var visibility = index === 0 ? `data-visible="true"` : `data-visible="false" style="display:none;"`;
            return `<${element} id="${this.originId}_${index}" class="slimtabs-pane" ${visibility}></${element}`;
        }


        private changeToTabFromUrlFragment(speed: number) {
             var fragment = window.location.hash;
             if (fragment !== "undefined" && fragment !== "") {
                 var fragmentTrimmed = fragment.substr(1); // Trim "#"
                 var pane = this.origin.find(`#${fragmentTrimmed}`).closest(".slimtabs-pane");
                 if (pane.length > 0) {
                     var paneId = pane.attr("id").split("_");
                     var index = +paneId[1];
                     var listItem = this.origin.find(`.slimtabs-tabs a[href="${fragment}"]`).closest("li");
                     $("html, body").animate({
                         scrollTop: this.origin.offset().top
                     }, 200);
                     this.changeTab(listItem, index, speed);
                 }
             }
         }

         private changeTab(listItem: JQuery, index: number, speed: number) {
            if (!listItem.hasClass("active")) {
                this.origin.find(".slimtabs-tabs li").removeClass("active");;
                this.origin.find(`${this.parameters.separationWrapper}[data-visible=true]`).attr("data-visible", "false").slideUp(speed);
                listItem.addClass("active");
                this.origin.find(`#${this.originId}_${index}`).attr("data-visible", "true").slideDown(speed);
            }
        }
    }

 }